const Actions = self => ({
    set: (value, feedback) => {
        self.value = value;
        self.feedback = feedback;
    },
});
export default Actions;
